import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../../Components/Breadcrumb/Breadcrumb'
import EvnVar from '../../../../EnvVar';
import Cookies from 'js-cookie';
import axios from 'axios'

function Evaluation() {
    const [evaluation, setEvaluation] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedData, setSelectedData] = useState(null);
    const [successText, setSuccessText] = useState(false)
    const [pointsData, setPointsData] = useState({
        "impact1": 0,
        "impact2": 0,
        "innovation": 0,
        "engagement1": 0,
        "engagement2": 0,
        "poc1": 0,
        "poc2": 0,
        "totalpoint": 0
    });

    const baseURL = EvnVar();
    const token = Cookies.get("jwt");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const config = {
                    method: "get",
                    url: `${baseURL}/user/getAmbassadors`,
                    headers: {
                        Authorization: token
                    },
                    withCredentials: true
                };

                const response = await axios.request(config);
                setEvaluation(response.data);
                // console.log("Get Evaluation =>", response.data);
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    const [gettingPointError, setGettingPointError] = useState()
    const handleSelectChange = async (e) => {
        setSelectedValue(e.target.value);
        const selectedItem = evaluation.find(item => item.rnumber === e.target.value);
        if (isNaN(selectedItem)) {
            setSelectedData(selectedItem);
        }

        if (!selectedItem?.id) return;

        try {
            const config = {
                method: "post",
                url: `${baseURL}/user/getPoints`,
                headers: {
                    'content-type': 'application/json',
                    Authorization: token,
                },
                data: JSON.stringify({ ambassador_id: selectedItem.id }),
                withCredentials: true,
            };

            const response = await axios.request(config);
            if (!response.data) {
                alert("No points found for ambassador.");
                return;
            };
            setPointsData(response.data);
            // console.log("Get Points", response.data);
        } catch (error) {
            console.log("Error Get Points:", error, error.response.data.error);
            setGettingPointError(error.response.data.error)
            setTimeout(() => {
                setGettingPointError()
            }, 1000);
        }
    };

    const handleValuePoints = (e) => {
        const { name, value } = e.target;
        const numValue = parseInt(value, 10);

        if (
            (['impact1', 'impact2', 'innovation'].includes(name) && (numValue >= 0 && numValue <= 20)) ||
            (['engagement1', 'engagement2', 'poc1', 'poc2'].includes(name) && (numValue >= 0 && numValue <= 10)) ||
            value === ''
        ) {
            setPointsData((prevData) => ({
                ...prevData,
                [name]: numValue || "",
            }));
        }
    };

    const pointSubmit = async (e) => {
        e.preventDefault();

        if (!selectedData || !selectedData.id) {
            alert("No ambassador selected.")
            // console.log("No ambassador selected.");
            return;
        }

        try {
            const pointData = {
                ...pointsData,
                ambassador_id: selectedData.id
            };

            // console.log("pointData===>", pointData);

            const config = {
                method: 'put',
                url: `${baseURL}/user/updatePoints`,
                headers: {
                    'content-type': 'application/json',
                    Authorization: token,
                },
                data: JSON.stringify(pointData),
                withCredentials: true,
            };

            const response = await axios.request(config);
            // console.log("Points sent:", response.data);
            setPointsData(response.data); // Update pointsData state with response if needed
            setSuccessText(true)
            setTimeout(() => {
                window.location.reload();
            }, 3000);

        } catch (error) {
            console.log("Error while sending points:", error);
            setGettingPointError(error.response.data.error)
            setTimeout(() => {
                setGettingPointError()
            }, 1000);
        }
    };

    return (
        <>
            <Breadcrumb data="Evaluation" />
            <div className='content-body'>
                {gettingPointError && <div className='text-danger' style={{ position: "absolute", top: "100px", right: "0", fontWeight: "500", backgroundColor: "#fff", padding: "0.75rem 2rem", boxShadow: "0 0 6px 3px #ddd", borderRadius: "10px 0 0 10px", transition: "ease-in-out 0.5s" }}>{gettingPointError}</div>}
                <div className="table-data">
                    <form onSubmit={pointSubmit}>
                        <div className='table-responsive'>
                            <table className='table table-bordered'>
                                <thead>
                                    <tr>
                                        <th colSpan={4}>FTL Ambassador - Jury Evaluation Sheet</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>Ambassador Name</th>
                                        <th colSpan={2}>
                                            <select onChange={handleSelectChange} value={selectedValue}>
                                                <option disabled value="">Select Ambassador</option>
                                                {evaluation && evaluation.map((value, index) => (
                                                    <option key={index} value={value.rnumber}>
                                                        {value.fullname}
                                                    </option>
                                                ))}
                                            </select>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>Member/ SRN ID</th>
                                        <th colSpan={2}>{selectedData?.rnumber}</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>Branch Location</th>
                                        <th colSpan={2}>{selectedData?.branch}</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>Region</th>
                                        <th colSpan={2}>{selectedData?.city}</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>Evaluation Criteria</th>
                                        <th rowSpan={2}>Maximium Points</th>
                                        <th rowSpan={2}>Points Awarded</th>
                                    </tr>
                                    <tr>
                                        <th>Criteria Description</th>
                                        <th>Criteria Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td rowSpan={2}>Impact</td>
                                        <td>Number of Individuals Trained in Financial and Tax Literacy</td>
                                        <td>20</td>
                                        <td><input type="number" max={20} min={0} className='form-control' onChange={handleValuePoints} name="impact1" value={pointsData.impact1} /></td>
                                    </tr>
                                    <tr>
                                        <td>Reach and Effectiveness of Social Media Initiatives</td>
                                        <td>20</td>
                                        <td><input type="number" max={20} min={0} className='form-control' onChange={handleValuePoints} name="impact2" value={pointsData.impact2} /></td>
                                    </tr>
                                    <tr>
                                        <td>Innovation</td>
                                        <td>Creativity and Originality in Delivering FTL Programs</td>
                                        <td>20</td>
                                        <td><input type="number" max={20} min={0} className='form-control' onChange={handleValuePoints} name="innovation" value={pointsData.innovation} /></td>
                                    </tr>
                                    <tr>
                                        <td rowSpan={2}>Engagement</td>
                                        <td>Frequency and Consistency of FTL Activities</td>
                                        <td>10</td>
                                        <td><input type="number" max={10} min={0} className='form-control' onChange={handleValuePoints} name="engagement1" value={pointsData.engagement1} /></td>
                                    </tr>
                                    <tr>
                                        <td>Level of Participant Engagement and Feedback</td>
                                        <td>10</td>
                                        <td><input type="number" max={10} min={0} className='form-control' onChange={handleValuePoints} name="engagement2" value={pointsData.engagement2} /></td>
                                    </tr>
                                    <tr>
                                        <td rowSpan={2}>Proof of Contribution</td>
                                        <td>Quality and Authenticity of Provided Proofs</td>
                                        <td>10</td>
                                        <td><input type="number" max={10} min={0} className='form-control' onChange={handleValuePoints} name="poc1" value={pointsData.poc1} /></td>
                                    </tr>
                                    <tr>
                                        <td>Comprehensive Documentation of Efforts and Achievements</td>
                                        <td>10</td>
                                        <td><input type="number" max={10} min={0} className='form-control' onChange={handleValuePoints} name="poc2" value={pointsData.poc2} /></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={2}>Total Score</th>
                                        <th>100</th>
                                        <th>{pointsData.totalpoint}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            {successText && <p className='text-success mb-0 me-3'>Data has been submited!</p>}
                            <button className='download-btn' type="submit">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default Evaluation
